var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('baidu-map',{staticClass:"bm-view",attrs:{"ak":"Gbnhd8Q9XtedQAq0Rq9xHdXGGHEj4hV7","center":_vm.center,"zoom":_vm.zoom,"showAddressBar":true,"scroll-wheel-zoom":true},on:{"ready":_vm.handler}},[_c('bm-marker',{attrs:{"position":_vm.center,"dragging":true}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c9921a0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/baiduMap/baiduMap.vue
// module id = null
// module chunks = 